<rotec-pages-v2>
  <a [routerLink]="userListUrl" routerLinkActive="pages-active-link">
    <h3 translate>User Manager</h3>
  </a>
</rotec-pages-v2>
